



























import Vue, { VueConstructor } from 'vue';
import * as signalR from '@aspnet/signalr';
import services from '../../services';
import { AxiosResponse, AxiosError } from 'axios';
import { Response, ErrorStatesOptions, Version } from '../../models';
import lang from '../../common/lang/de';
import { ToastMessage } from '../../plugins/toast/models/message';

const { HomeService } = services;

export default (Vue as VueConstructor<Vue & {
}>).extend({
  name: 'OsaFooter',
  data() {
    return {
      currentYear: 0 as number,
      load: true as boolean,
      connectionStatus: '' as string,
      iconType: '' as string,
      iconClass: '' as string,
      version: {
        CA: 'x' as string,
        CCS: 'x' as string,
      }
    };
  },
  created() {
    this.currentYear = new Date().getFullYear();
    this.getConnectionStatus();
    this.getVersions();
  },
  methods: {
    getConnectionStatus() {
      const connection = new signalR.HubConnectionBuilder().withUrl('/clientHub').build();

      connection.on('StatusServiceConnection', (status: boolean) => {
        this.connectionStatus = status ? 'Verbunden' : 'Unterbrochen';
        this.iconType = status ? 'check_circle_outline' : 'warning';
        this.iconClass = status ? 'icon-connection-up' : 'icon-connection-down';
        this.load = false;
      });

      connection.start();
    },
    getVersions() {
      this.$loader.show();
      HomeService.getVersions()
        .then((result: AxiosResponse<Version>) => {
          this.version.CA = result.data.versionCA as string;
          this.version.CCS = result.data.versionCSS as string;
          this.$loader.hide();
        })
        .catch((err: AxiosError) => {
          if (err.response !== undefined && (err.response.status === 401 || err.response.status === 500)) {
            this.showError(ErrorStatesOptions.NotAuthorized);
            this.$router.push('/');
          } else {
            this.showError(ErrorStatesOptions.UnexpectedError);
          }
        });
    },
    showError(error: ErrorStatesOptions) {
      const toast = {} as ToastMessage;
      switch (error) {
        case ErrorStatesOptions.NotAuthorized:
          toast.header = lang.global.error.NotAuthorized.header;
          toast.message = lang.global.error.NotAuthorized.message;
          break;
        case ErrorStatesOptions.UnexpectedError:
          toast.header = lang.global.error.unerwarteter.header;
          toast.message = lang.global.error.unerwarteter.message;
          break;
        default:
          toast.header = lang.global.error.unerwarteter.header;
          toast.message = lang.global.error.unerwarteter.message;
          break;
      }
      this.$toast.error(toast);
    }
  }
});
